/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useCallback } from 'react';
import { Modal } from 'antd';
import { Button } from "@mui/material";
import customStyles from "../../../../assets/styles/customStyles";
import clsx from "clsx";
import crudActions from "../../../CRUD/redux/actions";
import { useDispatch, useSelector } from "react-redux";
import usePrevious from "../Previous";
import { toast } from 'react-toastify';

export default function DeleteModal(props) {
    const { deleteDetails, deleteLoader, deleteError } = useSelector(state => state.crudReducer);
    const { id, name, url, title, visible, onClose, loadTasks, action } = props;
    const prevDeleteDetails = usePrevious(deleteDetails);
    const prevDeleteError = usePrevious(deleteError);
    const dispatch = useDispatch();

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const handleClose = useCallback((v) => {
        onClose(v);
    });

    const onDelete = () => {
        dispatch({
            type: crudActions.DELETE_DETAILS_START,
            url: url,
            title: title,
            id: id,
            action: action
        });
    }


    useEffect(() => {
        if (prevDeleteDetails !== undefined && deleteDetails && prevDeleteDetails !== deleteDetails) {
            handleClose(false);
            toast.dismiss();
            toast(deleteDetails);
            loadTasks();
        } else if (prevDeleteError !== undefined && deleteError && prevDeleteError !== deleteError) {
            handleClose(false);
            toast.dismiss();
            toast.error(deleteError?.error?.message);
        }
    }, [deleteDetails, deleteError]);

    const classes = customStyles();

    return (
        <Modal
            title={'Delete Confirmation'}
            open={visible}
            onOk={() => handleClose(false)}
            onCancel={() => handleClose(false)}
            className={clsx(classes.commonPopup, classes.deletePopup)}
            // // closeIcon={<CloseIcon />}
            footer={
                [
                    <Button
                        key="yes"
                        type='submit'
                        color='primary'
                        variant="contained"
                        className={clsx(classes.modalBtn, { [classes.loading]: deleteLoader })}
                        onClick={() => onDelete()}
                    >Yes</Button>,
                    <Button
                        key="no"
                        type='submit'
                        color='primary'
                        variant="contained"
                        className={clsx(classes.AddMoreBtn)}
                        onClick={() => handleClose(false)}
                    >No</Button>
                ]}>
            <p>Are you sure you want to <span className={classes.deleteRed}> Delete </span> {name} ?</p>
        </Modal>
    );
};

export const CustomModal = (props) => {
    const { title, visible, onClose, centered, onOpen, yesId, noId, text, loading, yesButton, noButton, customClasses, closeIcon = true } = props;
    const classes = customStyles();

    return (
        <Modal
            title={title}
            open={visible}
            closable={closeIcon}
            onOk={() => onClose(false)}
            onCancel={() => onClose(false)}
            centered={centered}
            className={clsx(classes.commonPopup, classes.deletePopup, customClasses)}
            footer={
                (yesButton || noButton) ? [
                    <React.Fragment key="yes">{
                        yesButton && <Button
                            type='submit'
                            color='primary'
                            variant="contained"
                            id={yesId}
                            className={clsx(classes.modalBtn, { [classes.loading]: loading })}
                            onClick={() => onOpen()}
                        >{yesButton}</Button>
                    }</React.Fragment>, <React.Fragment key="no">
                        {
                            noButton && <Button
                                key="no"
                                type='submit'
                                color='primary'
                                id={noId}
                                variant="contained"
                                className={clsx(classes.AddMoreBtn)}
                                onClick={() => onClose(false)}
                            >{noButton}</Button>
                        }
                    </React.Fragment>
                ] : false}>
            {text}
        </Modal>
    );
}